import gql from 'graphql-tag';

export default gql`
  fragment task on AssignedExercise {
    id
    name
    completed

    videoUrl
    imageUrl
    equipment
    description

    quantityType
    times
    sets
    reps
    durationType
    duration
  }
`;
